import { render, staticRenderFns } from "./myAttention.vue?vue&type=template&id=57b9be55"
import script from "./myAttention.vue?vue&type=script&lang=js"
export * from "./myAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports